import { render } from "./RegistrationView.vue?vue&type=template&id=135ace2c"
import script from "./RegistrationView.vue?vue&type=script&lang=js"
export * from "./RegistrationView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__